module.exports = __webpack_public_path__ + "static/media/amex-signup-header-dt.38651f7c.jpg";